import { useState, useEffect } from "react";
import { API } from "../assets/staticData";

let userToken = localStorage.getItem("userToken");

function useLanguages() {
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    async function fetchLanguages() {
      try {
        const response = await fetch(`${API}/languages?populate=*`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch languages");
        }
        const data = await response.json();

        // Ensure the languages are in the desired sequence
        const sortedLanguages = ["English", "Arabic", "Persian"].map((lang) =>
          data?.data.find((item) => item.attributes.language.toLowerCase() === lang.toLowerCase())
        );

        setLanguages(sortedLanguages.filter(Boolean)); 
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    }

    fetchLanguages();

    return () => {
      // Cleanup logic
    };
  }, []);

  return languages;
}

export default useLanguages;
